import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Check, Loader2, X } from "lucide-react";
import { api } from "../../lib/api";

export const PaymentReturn = ({ onPaid }) => {
  const [st, setSt] = useState(null);
  const [id] = useState(() => new URLSearchParams(window.location.search).get("paiement"));
  useEffect(() => {
    if (!id) return undefined;
    let alive = true, tries = 0;
    setSt({ loading: true });
    const check = () => api.get(`/checkout/${id}`).then((r) => {
      if (!alive) return;
      if (r.data?.paid) { setSt({ paid: true, title: r.data.title }); onPaid?.(); }
      else if (++tries < 5) setTimeout(check, 2500);
      else setSt({ paid: false, title: r.data?.title });
    }).catch(() => alive && setSt({ paid: false }));
    check();
    window.history.replaceState({}, "", window.location.pathname);
    return () => { alive = false; };
  }, [id, onPaid]);

  return (
    <AnimatePresence>
      {st && (
        <motion.div className="fixed inset-0 z-[90] bg-[#0C141B]/80 backdrop-blur-sm grid place-items-center p-5" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <motion.div initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="relative w-full max-w-md bg-[#F6F1E9] p-8 sm:p-10 text-center" data-testid="payment-return-dialog">
            <button onClick={() => setSt(null)} aria-label="Fermer" className="absolute top-4 right-4" data-testid="payment-return-close"><X className="w-5 h-5" /></button>
            {st.loading ? (
              <><Loader2 className="w-8 h-8 animate-spin mx-auto text-[#8A6420]" /><p className="mt-4">Confirmation du paiement…</p></>
            ) : st.paid ? (
              <>
                <span className="w-16 h-16 rounded-full bg-[#15202B] text-[#F6F1E9] grid place-items-center mx-auto"><Check className="w-7 h-7" /></span>
                <p className="f-sign text-5xl text-[#8A6420] mt-4">Merci !</p>
                <p className="f-display text-3xl mt-2 text-[#15202B]" data-testid="payment-success-title">{/articles$/.test(st.title || "") ? "Votre commande est confirmée." : `« ${st.title} » est à vous.`}</p>
                <p className="mt-4 text-[#2E3B47] font-light">Votre paiement est confirmé. Christine vous contactera très bientôt pour la livraison ou la cueillette.</p>
              </>
            ) : (
              <>
                <p className="f-display text-3xl text-[#15202B]">Paiement non complété</p>
                <p className="mt-4 text-[#2E3B47] font-light">Aucun montant n'a été prélevé. Vous pouvez réessayer, ou écrire à Christine avec le formulaire de contact.</p>
              </>
            )}
            {!st.loading && <button onClick={() => setSt(null)} className="btn-ink mt-8" data-testid="payment-return-ok">Retour au site</button>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
